import React from "react";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutline from "@material-ui/icons/DeleteOutline";

export function Remove(props) {
  return (
    <IconButton {...props} color="primary" style={{ padding: "6px" }}>
      <DeleteOutline />
    </IconButton>
  );
}
